import { Loader2, AlertTriangle } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

interface MigrationProgressProps {
  isExecuting: boolean;
}

export function MigrationProgress({ isExecuting }: MigrationProgressProps) {
  if (!isExecuting) return null;

  return (
    <Card>
      <CardContent className="py-8">
        <div className="flex flex-col items-center gap-4" role="status" aria-live="polite">
          <Loader2 className="h-8 w-8 animate-spin text-primary" aria-hidden="true" />
          <h3 className="text-lg font-semibold">Migration in progress...</h3>
          <div className="w-full max-w-md h-2 rounded-full bg-secondary overflow-hidden">
            <div className="h-full w-1/3 bg-primary rounded-full animate-indeterminate" />
          </div>
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <AlertTriangle className="h-4 w-4" />
            <span>Do not close this page.</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
